<template>
  <div class="search-header__views">
    <label
      :class="{ _active: modeView === 'list' }"
      class="search-header__view"
      title="Показать список"
      @click="toggleModeView(true)"
    >
      <input v-model="modeView" type="radio" name="mode-view" value="list" />
      <svg class="search-header__view-icon" width="20" height="20">
        <use xlink:href="#list" />
      </svg>
    </label>

    <label
      :class="{ _active: modeView === 'table' }"
      class="search-header__view"
      title="Показать таблицу"
      @click="toggleModeView(false)"
    >
      <input v-model="modeView" type="radio" name="mode-view" value="table" />
      <svg class="search-header__view-icon" width="20" height="20">
        <use xlink:href="#table" />
      </svg>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    outerModeView: {
      type: String,
      default: 'list'
    }
  },
  data() {
    return {
      modeView: ''
    };
  },
  created() {
    this.modeView = this.outerModeView;
  },
  methods: {
    toggleModeView(mode) {      
      this.$emit(
        'toggleMode',
        mode,
        this.modeView === 'list' ? 'table' : 'list'
      );
    }
  }
};
</script>
